export default __webpack_public_path__ + "static/media/app7-section3-image2.81694cf6.png";